export const MARKETING_SET_PAGE_NUMBER = 'MARKETING_SET_PAGE_NUMBER';
export const MARKETING_SET_PRODUCT_CARD_EXPANDED =
  'MARKETING_SET_PRODUCT_CARD_EXPANDED';
export const MARKETING_QUERY_PARAM = 'MARKETING_QUERY_PARAM';
export const MARKETING_SET_PART_NUMBER = 'MARKETING_SET_PART_NUMBER';
